import { Component, EventEmitter, Input, Output, OnChanges, SimpleChanges, OnInit } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
  selector: 'app-lottery-results',
  templateUrl: './lottery-results.component.html',
  styleUrls: ['./lottery-results.component.scss']
})
export class LotteryResultsComponent implements OnChanges, OnInit {
  visiblePages: number[] = [];
  isMobile = false;

  @Input() title?: string;
  @Input() subtitle?: string;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Input() results: any[] = [];
  @Input() pagination: { currentPage: number, totalPages: number } = { currentPage: 1, totalPages: 1 };;
  @Input() columns: { header: string; field: string }[] = [];  // Colonne dinamiche
  @Input() isVotedFn!: (index: number) => boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Input() onVoteFn!: (index: number, ticket: any) => void;

  @Output() pageChange = new EventEmitter<number>();

  constructor(private deviceDetectorService: DeviceDetectorService) { }

  ngOnInit(): void {
    this.checkIfMobile()
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['pagination']) {
      this.updateVisiblePages();
    }
  }

  changePage(page: number): void {
    if (page >= 1 && page <= this.pagination.totalPages) {
      this.pageChange.emit(page);
      this.updateVisiblePages();
    }
  }

  updateVisiblePages(): void {
    const total = this.pagination.totalPages;
    const current = this.pagination.currentPage;
    const pagesToShow = 5;

    if (total <= pagesToShow) {
      // Se il totale delle pagine è minore o uguale a 5, mostriamo tutte le pagine
      this.visiblePages = Array.from({ length: total }, (_, i) => i + 1);
    } else {
      if (current <= 3) {
        // Se siamo nelle prime 3 pagine, mostriamo le prime 5
        this.visiblePages = [1, 2, 3, 4, 5];
      } else if (current >= total - 2) {
        // Se siamo nelle ultime 3 pagine, mostriamo le ultime 5
        this.visiblePages = [total - 4, total - 3, total - 2, total - 1, total];
      } else {
        // Altrimenti mostriamo la pagina corrente al centro
        this.visiblePages = [current - 2, current - 1, current, current + 1, current + 2];
      }
    }
  }


  private checkIfMobile(): void {
    this.isMobile = this.deviceDetectorService.isMobile();
  }

}
